/* AJAX Loader*/
function ajaxLoader(file, request, typ) {
    var xmlhttp;
    if (window.XMLHttpRequest) {/*Code für IE7+, Firefox, Chrome, Opera, Safari*/
        xmlhttp = new XMLHttpRequest();
    }
    else {/*Code für IE6, IE5*/
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    /*Wenn Browser kein Request unterstützt*/
    if (xmlhttp == null) {
    }

    xmlhttp.onreadystatechange = function () {
        /*Wenn Skript OK zurück gibt Werte zurück geben*/
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            if (typ == "input") {
                document.getElementById(request).value = xmlhttp.responseText;
            }
            else if (typ == "text") {
                document.getElementById(request).innerHTML = xmlhttp.responseText;
            }
            else if (typ == "trophaen") {
                document.getElementById(request).innerHTML = xmlhttp.responseText;

                /* Prüfung ob neue Trophäen erreicht wurden und dann anzeige aktuallisieren */
                if ($('input#anzahl_neu').length > 0) {
                    if (document.getElementById("anzahl_neu").value > 1) {
                        for (var i = 0; i < document.getElementById("anzahl_neu").value; i++) {
                            document.getElementById(document.getElementById('trophae' + i).value).src = document.getElementById('trophae_img' + i).value;
                            document.getElementById(document.getElementById('trophae' + i).value).alt = 'Trophäe erreicht';
                            document.getElementById(document.getElementById('trophae' + i).value).title = 'Trophäe erreicht';
                        }
                    }
                    else if (document.getElementById("anzahl_neu").value == 1) {
                        document.getElementById(document.getElementById('trophae0').value).src = document.getElementById('trophae_img0').value;
                        document.getElementById(document.getElementById('trophae0').value).alt = 'Trophäe erreicht';
                        document.getElementById(document.getElementById('trophae0').value).title = 'Trophäe erreicht';
                    }
                }
            }
            else if (typ == "werbung") {
                if (xmlhttp.responseText == 0) {
                    // Werbung ausblenden
                    if ($('div#top-adverts').length > 0) {
                        document.getElementById("top-adverts").style.display = "none";
                    }

                    if ($('div#right-adverts').length > 0) {
                        document.getElementById("right-adverts").style.display = "none";
                    }

                    if ($('div#bill-adverts').length > 0) {
                        document.getElementById("bill-adverts").style.display = "none";
                    }

                    if ($('div#bottom-adverts').length > 0) {
                        document.getElementById("bottom-adverts").style.display = "none";
                    }
                } else {
                    // Werbung einblenden
                    if ($('div#top-adverts').length > 0) {
                        document.getElementById("top-adverts").style.display = "block";
                    }

                    if ($('div#right-adverts').length > 0) {
                        document.getElementById("right-adverts").style.display = "block";
                    }

                    if ($('div#bill-adverts').length > 0) {
                        document.getElementById("bill-adverts").style.display = "inherit";
                    }

                    if ($('div#bottom-adverts').length > 0) {
                        document.getElementById("bottom-adverts").style.display = "inherit";
                    }
                }
            }
            else {
                antwort = xmlhttp.responseText;
            }
        }
    }

    xmlhttp.open("GET", file, true);
    xmlhttp.send();
}

/* DOM Objekt laden*/
$(document).ready(function () {
    /* Prüfung ob Top Werbung gezeigt wird */
    if ($('div#top-adverts').length == 0) {
        document.getElementById("body").style.marginTop = "10px";
    }
    else {
        document.getElementById("body").style.marginTop = "110px";
    }

    /* Timer für Kontostand aktivieren */
    if (($('div#gamepanel').length > 0) && ($('span#kontostand').length > 0)) {
        var timerKontostand = setInterval(function () {
            ajaxLoader(domain + '/ajax/ajax_kontostand.php', 'kontostand', 'text');
        }, 30000);
    }
    else {
        clearTimeout(timerKontostand);
    }

    /* Timer für Duelle aktivieren */
    if ($('div#duelle').length > 0) {
        var timerDuelle = setInterval(function () {
            ajaxLoader(domain + '/ajax/ajax_duelle.php?ajax=on', 'duelle', 'text');
        }, 10000);
    }
    else {
        clearTimeout(timerDuelle);
    }

    /* Timer für Duelle aktivieren */
    if ($('div#liveduell').length > 0) {
        duellid = document.getElementById("duellid").value;
        ajaxLoader(domain + '/ajax/ajax_duellinfo.php?duellid=' + duellid, 'liveduell', 'text');

        var timerDuellInfo = setInterval(function () {
            duellid = document.getElementById("duellid").value;
            ajaxLoader(domain + '/ajax/ajax_duellinfo.php?duellid=' + duellid, 'liveduell', 'text');
        }, 10000);
    }
    else {
        clearTimeout(timerDuellInfo);
    }

    var $liveticker_1 = $("#liveticker_1");
    var updateLiveticker = function(){
        $liveticker_1.fadeOut(300);
        ajaxLoader(domain + '/ajax/ajax_liveticker.php?ticker=1', 'liveticker_1', 'text');
        $liveticker_1.fadeIn(300);
    };

    var timerTicker = null;
    /* Timer für Liveticker aktivieren */
    if ($('div#liveticker').length > 0) {
            var $ticker = $("#ticker");
        $ticker.find(".handle").on("click", function(){
            var $this = $(this);

            if($ticker.hasClass('open'))
            {
                $.ajax({url: domain+"/ajax/ajax_ui.php?liveticker=0"});
                $ticker.removeClass('open');
                $this.find('.handle-icon').removeClass('fa-chevron-circle-right').addClass('fa-chevron-circle-left')
                timerTicker = clearInterval(timerTicker);
            } else {
                $.ajax({url: domain+"/ajax/ajax_ui.php?liveticker=1"});
                $ticker.addClass('open');
                $this.find('.handle-icon').removeClass('fa-chevron-circle-left').addClass('fa-chevron-circle-right')
                updateLiveticker();
                timerTicker = setInterval(updateLiveticker, 15000);
                    }
                });

        if(    typeof(UI_SETTINGS) === "undefined"
            || typeof(UI_SETTINGS['liveticker']) === "undefined"
            || UI_SETTINGS['liveticker'] === true
        ) {
            updateLiveticker();
            timerTicker = setInterval(updateLiveticker, 15000);
    }
    }

    /* Timer für Onlinestatus aktivieren */
    if ($('span#online').length > 0) {
        ajaxLoader(domain + '/ajax/ajax_online.php', 'online', 'text');

        var timerOnline = setInterval(function () {
            ajaxLoader(domain + '/ajax/ajax_online.php', 'online', 'text');
        }, 30000);
    }
    else {
        clearTimeout(timerOnline);
    }

    /* Timer für Preloader */
    if ($('div#werbung').length > 0) {
        if (document.getElementById("ads").value == 1) {
            var zaehler = 0;

            var timerPreload = setInterval(function () {
                /* Panel beschreiben*/
                prozent = zaehler * 0.33333333;
                document.getElementById("panelpreloader").style.width = prozent + '%';

                if (zaehler > 20) {
                    /*
                     sekunden = (3000 - zaehler) / 100;
                     sekunden = Math.ceil(sekunden);
                     document.getElementById("timer").innerHTML = '<strong>' + sekunden + ' Sek.</strong>';
                     */

                    prozent = Math.ceil(prozent);
                    document.getElementById("timer").innerHTML = '<strong>' + prozent + ' %</strong>';
                }

                if (zaehler > 50) {
                    document.getElementById("timerdesc").innerHTML = '<strong>Spiel wird geladen</strong>';
                }

                if (zaehler == 300) {
                    /* Prüfung ob lange Beschriebung angezeigt wird */
                    if ($('div#gamedesclong').length > 0) {
                        document.getElementById("gamedesclong").style.display = 'table';
                    }

                    /* Spiel und Beschreibung einblenden */
                    document.getElementById("gamepanel").style.display = 'table';
                    document.getElementById("gamedesc").style.display = 'table';
                    document.getElementById("werbung").style.display = 'none';

                    clearTimeout(timerPreload);
                }

                zaehler = zaehler + 1;
            }, 100);
        }
        else {
            if ($('div#gamedesclong').length > 0) {
                document.getElementById("gamedesclong").style.display = 'table';
            }

            /* Spiel und Beschreibung einblenden */
            document.getElementById("gamepanel").style.display = 'table';
            document.getElementById("gamedesc").style.display = 'table';
            document.getElementById("werbung").style.display = 'none';
        }
    }
});

/* Funktionen laden */
/* Melden eines Communitybeitrages */
function comMelden(id, funktion, request) {
    ajaxLoader(domain + '/ajax/ajax_community.php?melden=' + id + '&funktion=' + funktion, request, 'text');

    if (funktion == "melden") {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-warning alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>BEITRAG ERFOLGREICH GEMELDET</h3>Der Beitrag wurde erfolgreich gemeldet. Unsere Moderatoren schauen sich den gemeldeten Beitrag an.<div class="space25"></div></div></div></div>';
    }
    else {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-info alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>MELDUNG ZURÜCKGEZOGEN</h3>Ihre Meldung zu dem Beitrag wurde zurück gezogen.<div class="space25"></div></div></div></div>';
    }
}

/* Melden eines Communityantwort */
function comMeldenAntwort(id, funktion, request) {
    ajaxLoader(domain + '/ajax/ajax_community.php?melden_antwort=' + id + '&funktion=' + funktion, request, 'text');

    if (funktion == "melden") {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-warning alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>ANTWORT ERFOLGREICH GEMELDET</h3>Die Antwort wurde erfolgreich gemeldet. Unsere Moderatoren schauen sich die gemeldete Antwort an.<div class="space25"></div></div></div></div>';
    }
    else {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-info alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>MELDUNG ZURÜCKGEZOGEN</h3>Ihre Meldung zur Antwort wurde zurück gezogen.<div class="space25"></div></div></div></div>';
    }
}

/* Community Beitrag abonnieren */
function comAbo(id, funktion, request) {
    ajaxLoader(domain + '/ajax/ajax_community.php?abonnieren=' + id + '&funktion=' + funktion, request, 'text');

    if (funktion == "abonnieren") {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-success alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>BEITRAG ERFOLGREICH ABONNIERT</h3>Der Beitrag wurde erfolgreich abonniert. Sie erhalten ab jetzt für alle neuen Antworten in diesem Beitrag eine Nachricht in Ihr Postfach.<div class="space25"></div></div></div></div>';
    }
    else {
        document.getElementById("status").innerHTML = '<div class="row"><div class="col-md-12"><div class="alert alert-info alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><h3>ABONNEMENT AUFGEHOBEN</h3>Das Abonnement für diesen Beitrag wurde aufgehoben. Sie erhalten ab jetzt keine Nachrichten mehr bei neuen Antworten<div class="space25"></div></div></div></div>';
    }
}

/* Messages auf Sidebar ausgeben */
function messages(id, text) {
    document.getElementById(id).innerHTML = text;
}

/* nur Buchstaben erlaubt */
function nurBuchstaben(feld) {
    var val = document.getElementById(feld).value.replace(/[^a-zA-zÄÖÜäöüß.\-\_ ]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Mail erlaubt */
function nurAlpha(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-z ]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Mail erlaubt */
function nurMail(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-z\-_@.+]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Mail erlaubt */
function nurURL(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-z:\-\_.\/]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Strasse erlaubt */
function nurStrasse(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-zÄÖÜäöüß.\-_ ]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Nickname erlaubt */
function nurNickname(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-z\-_.]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Passwort erlaubt */
function nurPasswort(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9a-zA-z!$#*]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Zahlen erlaubt */
function nurZahl(feld) {
    var $field = (typeof feld === 'string' ? document.getElementById(feld) : feld);
    $field.value = $field.value.replace(/[^0-9]/g, '');
}

/* nur Zahlen mit Komma erlaubt */
function nurBetrag(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9,]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Telefonnummer erlaubt */
function nurTelefon(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9\-\+\/() ]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Datum erlaubt */
function nurDatum(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9.\-]/g, '');
    document.getElementById(feld).value = val;
}

/* nur Uhrzeit erlaubt */
function nurUhrzeit(feld) {
    var val = document.getElementById(feld).value.replace(/[^0-9:]/g, '');
    document.getElementById(feld).value = val;
}

/* Mailadresse überprüfen */
function checkMail(email) {
    var regex = new RegExp('^([a-zA-Z0-9\\-\\.\\_]+)' + '(\\@)' + '([a-zA-Z0-9\\-\\.]+)' + '(\\.)' + '([a-zA-Z]{2,4})$');
    return (regex.test(email));
}

/* Automatisches Passwort generieren */
function rnd_passwort(id, typ) {
    ajaxLoader(domain + '/ajax/passwort.php', id, typ);
}

/* Mailadresse überprüfen */
function pruefeMail(id, error, typ) {
    if (document.getElementById(id).value.length > 0) {
        ajaxLoader(domain + '/ajax/ajax_register.php?art=email&value=' + document.getElementById(id).value, error, typ);
    }
    else {
        document.getElementById(error).innerHTML = '';
    }
}

/* Geburtsdatum überprüfen */
function pruefeGeb(id, id1, id2, error, typ) {
    if ((document.getElementById(id).value.length > 1) && (document.getElementById(id1).value.length > 1) && (document.getElementById(id2).value.length > 3)) {
        ajaxLoader(domain + '/ajax/ajax_register.php?art=geb&geb_tag=' + document.getElementById(id).value + '&geb_monat=' + document.getElementById(id1).value + '&geb_jahr=' + document.getElementById(id2).value, error, typ);
    }
    else if ((document.getElementById(id).value.length == 0) && (document.getElementById(id1).value.length == 0) && (document.getElementById(id2).value.length == 0)) {
        document.getElementById(error).innerHTML = '';
    }
    else {
        document.getElementById(error).innerHTML = '<span class="fam-exclamation"></span>&nbsp;<span class="rot"><strong>Unvollständiges</strong> Geburtsdatum</span>';
    }
}

/* Wiederholung überprüfen */
function vergleichWerte(id, id2, error) {
    if (document.getElementById(id2).value.length > 0) {
        if (document.getElementById(id).value == document.getElementById(id2).value) {
            document.getElementById(error).innerHTML = '<span class="fam-accept"></span>&nbsp;<span class="gruen">identisch</span>';
        }
        else {
            document.getElementById(error).innerHTML = '<span class="fam-exclamation"></span>&nbsp;<span class="rot">nicht identisch</span>';
        }
    }
    else {
        document.getElementById(error).innerHTML = '';
    }
}

/* Nicknamen überprüfen*/
function pruefeNickname(id, error, typ) {
    if (document.getElementById(id).value.length > 7) {
        ajaxLoader(domain + '/ajax/ajax_register.php?art=nick&value=' + document.getElementById(id).value, error, typ);
    }
    else if (document.getElementById(id).value.length == 0) {
        document.getElementById(error).innerHTML = '';
    }
    else {
        document.getElementById(error).innerHTML = '<span class="fam-exclamation"></span>&nbsp;<span class="rot">Geben Sie mindestens 8 Zeichen ein</span>';
    }
}

/* Nicknamen überprüfen*/
function pruefePasswort(id, error, typ) {
    if (document.getElementById(id).value.length > 5) {
        ajaxLoader(domain + '/ajax/ajax_register.php?art=pw&value=' + document.getElementById(id).value, error, typ);
    }
    else if (document.getElementById(id).value.length == 0) {
        document.getElementById(error).innerHTML = '';
    }
    else {
        document.getElementById(error).innerHTML = '<span class="fam-exclamation"></span>&nbsp;<span class="rot">Geben Sie mindestens 6 Zeichen ein</span>';
    }
}

/* IBAN errechnen */
function getIBAN(konto, blz, land, ausgabe, typ) {
    if ((document.getElementById(konto).value.length > 5) && (document.getElementById(blz).value.length == 8)) {
        ajaxLoader(domain + '/ajax/ajax_register.php?art=iban&konto=' + document.getElementById(konto).value + '&blz=' + document.getElementById(blz).value + '&land=' + land, ausgabe, typ);
    }
    else {
        document.getElementById(ausgabe).innerHTML = '';
    }
}

/* IBAN übernehmen */
function setIBAN(iban, ziel) {
    document.getElementById(ziel).value = iban;
}

/* Freund hinzufügen */
function addFreund(uid, art) {
    ajaxLoader(domain + '/ajax/ajax_freunde.php?funktion=add&uid=' + uid + '&art=' + art, 'status', 'text');
    loadFreund();
}

/* Freund löschen */
function delFreund(uid) {
    ajaxLoader(domain + '/ajax/ajax_freunde.php?funktion=del&uid=' + uid, 'status', 'text');
    var elem = document.getElementById(uid);
    elem.parentNode.removeChild(elem);
    loadFreund();
}

/* Freunde laden */
function loadFreund() {
    ajaxLoader(domain + '/ajax/ajax_freunde.php?funktion=load', 'freunde', 'text');

    if ($('strong#freunde_liste').length > 0) {
        ajaxLoader(domain + '/ajax/ajax_freunde.php?funktion=load', 'freunde_liste', 'text');
    }
}

/* Artikel in den Warenkorb legen */
function addWK(id) {
    ajaxLoader(domain + '/ajax/ajax_shop.php?funktion=add&id=' + id, 'status', 'text');
    loadWK();
}

/* Artikel in den Warenkorb legen */
function loadWK() {
    ajaxLoader(domain + '/ajax/ajax_shop.php?funktion=load', 'warenkorb', 'text');
}

var checkflag = "false";
function selectAll(feld, anzahl) {
    //alert(feld + ' | ' + anzahl + ' | ' + checkflag);
    if (checkflag == "false") {
        for (i = 0; i < anzahl; i++) {
            document.getElementById(feld + i).checked = true;
        }
        checkflag = "true";
        return " Alle abwählen ";
    }
    else {
        for (i = 0; i < anzahl; i++) {
            document.getElementById(feld + i).checked = false;
        }
        checkflag = "false";
        return " Alle auswählen ";
    }
}

function setValue(id, wert) {
    document.getElementById(id).value = wert;
}

/* Nicknamen validieren */
function validNickname(id, error, typ) {
    if (document.getElementById(id).value.length > 4) {
        ajaxLoader(domain + '/ajax/ajax_nickname.php?art=nick&value=' + document.getElementById(id).value, error, typ);
    }
    else {
        document.getElementById(error).innerHTML = '';
    }
}

/* Focus auf ein Textfeld setzen */
function setFocus(feld) {
    document.getElementById(feld).focus();
}

/**
 * Diese Funktion wird durch die Bannergames gerufen.
 *
 * @param bannergame
 */
function bannerKlick(bannergame)
{
    ajaxLoader(domain+"/ajax/ajax_banner.php?id="+bannergame);
    $('#banner-'+bannergame).remove()
}

/* Ausblenden des Werbeframes */
if (document.getElementById('werbevideo'))
	{
	document.domain = 'spielenxxl.de';
	function ausblenden()
		{
		document.getElementById("werbevideo").style.display = 'none';
		clearTimeout(WerbungLoader);
		}

	var sec = 0;
	var WerbungLoader = setInterval(function ()
		{
		if (sec == 12)
			{
			ausblenden();
			}
		sec = sec + 1;
		/*console.log(sec);*/
		}, 10000);
	}
